import axios from "axios";

export default async function fetchQuestionSetting() {
    const url = `${process.env.NEXT_PUBLIC_QUESTION_CDN}?q=${new Date().getTime()}`;
    let result = null;
    const res = await axios({
        method: "get",
        url: url,
    });
    if (res.status === 200) {
        result = res.data;
        console.log("🚀 ~ fetchQuestionSetting ~ result:", result);
    }
    return result;
}
